module.exports = __webpack_public_path__ + "static/img/Bachelor_010449.05273cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010449.jpg
// module id = 167
// module chunks = 0